module.exports = __webpack_public_path__ + "media/images/how_it_works_2-ce5045460ed6dd9178d3d809e2207dc9.png";